// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.settings_dashboard__FHk5D {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.settings_cont2__VlNwH {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.settings_bodythemelight__daVLj {
  background-color: #f3f6f9;
}

.settings_bodythemedark__CUjRX {
  background-color: #151521;
}

.settings_headerthemelight__-DecU {
  background-color: #fff;
}

.settings_headerthemedark__VXMQL {
  background-color: #151521;
}

.settings_menuthemelight__xa936 {
  background-color: #fff;
}

.settings_menuthemedark__0RlW9 {
  background-color: #151521;
}

.settings_menulinklight__2ukHf {
  color: #60677e !important;
}

.settings_menulinklightSelected__-Sh8x {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.settings_menulinkdarkSelected__qg5eL {
  color: #fff !important;
  border-radius: 10px;
}

.settings_menulinkdark__ZEp0Q {
  color: #60677e !important;
}

.settings_menulinklight__2ukHf:hover {
  color: #1d1d1d !important;
}

.settings_menulinkdark__ZEp0Q:hover {
  color: #fff !important;
}

.settings_headinglight__doSQ0 {
  color: #60677e;
}

.settings_headingdark__n\\+TEX {
  color: #60677e;
}

.settings_searchboxlight__Exe8H {
  background-color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy {
  background-color: #1e1e2d;
  color: #60677e;
}

.settings_searchboxdark__0LYGy::placeholder {
  color: #60677e;
}

.settings_tableheadlight__I2wDM {
  background-color: #e9eaf0;
}

.settings_tableheaddark__BAzcZ {
  background-color: #1e1e2d;
  color: #60677e;
}

.settings_tablebodylight__F8haX {
  background-color: #fff;
}
.settings_tablebodylight__F8haX:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.settings_tablebodydark__qeszF {
  background-color: #1e1e2d;
  color: #60677e;
}
.settings_tablebodydark__qeszF:hover {
  background-color: #252530;
  cursor: pointer;
}

.settings_paginationlight__BGULt {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_paginationdark__Hz6pf {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_formthemelight__HnEnB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.settings_formthemedark__ffb0i {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.settings_formthemedark__ffb0i ::placeholder {
  color: #60677e;
}

.settings_viewformlight__AIIgi {
  background-color: #f3f6f9;
}

.settings_viewformdark__a2qUr {
  background-color: #151521;
}

.settings_permissionboxlight__UvL2i {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.settings_permissionboxdark__qBhr4 {
  background-color: #151521;
  border: none;
}

.settings_errormsgclr__QmeiF {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.settings_graphclrlight__rlfpD {
  background-color: #fff;
}

.settings_graphclrdark__tho2P {
  background-color: #1e1e2d;
}

#settings_card1bglight__mR3L5 {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#settings_card1bgdark__HX9ph {
  background: #392f28;
}

#settings_card2bglight__\\+y-JH {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#settings_card2bgdark__Kfhe7 {
  background: #1c3238;
}

#settings_card3bglight__XbcQO {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#settings_card3bgdark__ILj6B {
  background: #3a2434;
}

#settings_card4bglight__fGD5L {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#settings_card4bgdark__0tK9O {
  background: #2f264f;
}

.settings_actionbtnlight__4Sk0H {
  color: rgba(70, 71, 91, 0.8705882353);
}

.settings_actionbtndark__La-Jh {
  color: #60677e;
}

.settings_profiledropdownlight__NbgyO {
  background-color: #fff;
}

.settings_profiledropdowndark__D0QpQ {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .settings_cont2__VlNwH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
.settings_settingsection__xu5at {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.settings_settingsection__xu5at #settings_settingsheading__E8AHc {
  font-size: 18px;
  font-family: "SFUIDisplay-Medium";
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z {
  color: #60677e !important;
  margin-right: 50px;
  font-size: 15px;
  font-family: "SFUIDisplayRegular";
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  padding: 16px 20px;
  position: relative;
  margin-left: -10px;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO {
  color: #39979d !important;
  margin-right: 50px;
  font-size: 15px;
  font-family: "SFUIDisplayRegular";
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  padding: 15px 20px;
  position: relative;
  margin-left: -10px;
  border-bottom: 2px solid #39979d;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:hover {
  color: #39979d !important;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO:hover {
  color: #39979d !important;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:after {
  background: none repeat scroll 0 0 transparent;
  bottom: 0;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  background: #39979d;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
  border-bottom: 2px solid #39979d;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:hover:after {
  width: 100%;
  left: 0;
}
.settings_settingsection__xu5at #settings_layoutnav__xQYLn {
  border-radius: 5px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj {
  margin-top: 30px;
  padding: 30px;
  border-radius: 10px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_savebtn__yNpbe {
  border: none;
  border-radius: 5px;
  background-color: #39979d;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
  font-family: "SFUIDisplayRegular";
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_savebtn__yNpbe:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox__7agbd {
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox1__5RkFm {
  padding: 5px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
  font-family: "SFUIDisplayRegular";
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel__Bs5lx {
  font-family: "SFUIDisplayRegular";
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel1__b1qS9 {
  color: #f8f9fa;
  font-family: "SFUIDisplayRegular";
  font-size: 12px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_logo__2Nn6k {
  border: 1px solid rgba(81, 83, 101, 0.28);
  padding: 10px;
  margin-bottom: 20px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_editbtnsection__8ps9W {
  position: relative;
  margin-top: -37px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm {
  margin-left: 175px;
  font-size: 14px;
  background-color: #60677e;
  padding: 5px;
  border-radius: 50%;
  color: #e9ecef;
  cursor: pointer;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm:hover {
  background-color: #39979d;
}

.settings_upload__Nn90h {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  padding: 6px 0px 0px 3px;
  width: 90px;
  margin-left: 205px;
  margin-top: -45px;
  border-radius: 5px;
}

.settings_uploadicon__tIHlL {
  color: #1d1d1d;
  font-size: 18px;
  cursor: pointer;
}
.settings_uploadicon__tIHlL:hover {
  color: #39979d;
}

.settings_crossicon__Z8MI\\+ {
  color: #1d1d1d;
  font-size: 16px;
  margin-left: 40px;
  cursor: pointer;
}
.settings_crossicon__Z8MI\\+:hover {
  color: #39979d;
}

.settings_navitemli__4IC51 {
  margin-left: 20px;
}

@media only screen and (max-width: 878px) {
  #settings_layoutnav__xQYLn {
    display: flex !important;
  }
  .settings_settingslinks__vcT1Z {
    margin-right: 30px !important;
  }
}
@media only screen and (max-width: 548px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 20px !important;
    font-size: 14px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 400px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 0px !important;
    font-size: 13px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 600px) {
  #settings_dashboardcont2__qbjfj {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/settings.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AAjQA;EACI,mBAAA;EACA,oBAAA;AAmQJ;AAjQI;EACI,eAAA;EACA,iCDqEQ;AC8LhB;AAjQI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCDgES;EC/DT,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAmQR;AAhQI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCDmDS;EClDT,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;AAkQR;AA9PI;EACI,yBAAA;AAgQR;AA7PI;EACI,yBAAA;AA+PR;AA5PI;EACI,8CAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EAEA,SAAA;EACA,kBAAA;EACA,mBDiBW;EChBX,iDAAA;EACA,QAAA;EACA,gCAAA;AA6PR;AA3PM;EACE,WAAA;EACA,OAAA;AA6PR;AA1PK;EACG,kBAAA;AA4PR;AAzPM;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AA2PV;AAzPgB;EACI,YAAA;EACA,kBAAA;EACA,yBDLD;ECMC,aAAA;EACA,WDfN;ECgBM,eAAA;EACA,gBAAA;EACA,iCDHH;AC8PjB;AAzPoB;EACI,2CDZH;ACuQrB;AAxPgB;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AA0PpB;AAxPgB;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDtCH;ECuCG,cDnCH;ECoCG,iCDvBH;ACiRjB;AAxPgB;EACI,iCD1BH;EC2BG,eAAA;AA0PpB;AAxPgB;EACI,cAAA;EACA,iCD/BH;ECgCG,eAAA;AA0PpB;AAvPgB;EACI,yCAAA;EACA,aAAA;EACA,mBAAA;AAyPpB;AAvPgB;EACI,kBAAA;EACA,iBAAA;AAyPpB;AAtPgB;EACI,kBAAA;EACA,eAAA;EACA,yBD7DH;EC8DG,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAwPpB;AAtPqB;EACG,yBD9DL;ACsTnB;;AAhPA;EACI,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAmPJ;;AAjPA;EACI,cDvFU;ECwFV,eAAA;EACA,eAAA;AAoPJ;AAlPI;EACI,cDrFW;ACyUnB;;AAjPA;EACI,cDhGU;ECiGV,eAAA;EACA,iBAAA;EACA,eAAA;AAoPJ;AAlPI;EACG,cD/FY;ACmVnB;;AA/OA;EACI,iBAAA;AAkPJ;;AA7OA;EACG;IACC,wBAAA;EAgPF;EA9OC;IACC,6BAAA;EAgPF;AACF;AA7OA;EAEI;IACC,6BAAA;IACA,0BAAA;EA8OH;EA3OE;IACI,0BAAA;EA6ON;AACF;AAzOC;EAEG;IACC,4BAAA;IACA,0BAAA;EA0OH;EAvOE;IACI,0BAAA;EAyON;AACF;AAtOA;EACI;IACI,wBD5HI;IC6HJ,UD5HG;IC6HH,kBAAA;IACA,aDnIW;EC2WjB;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n        font-family: $sffont-medium;\n    }\n    .settingslinks{\n        color: #60677e !important;\n        margin-right: 50px;\n        font-size: 15px;\n        font-family: $sffont-regular;\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        padding: 16px 20px;\n        position: relative;\n        margin-left: -10px;   \n    }\n\n    .settingsgeneral{\n        color: $primary-btncolor !important;\n        margin-right: 50px;\n        font-size: 15px;\n        font-family: $sffont-regular;\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        padding: 15px 20px;\n        position: relative;\n        margin-left: -10px;  \n        border-bottom: 2px solid  $primary-btncolor;\n    }\n\n    \n    .settingslinks:hover{\n        color:  $primary-btncolor !important;\n    }\n    \n    .settingsgeneral:hover{\n        color:  $primary-btncolor !important;\n      }\n\n    .settingslinks:after {    \n        background: none repeat scroll 0 0 transparent;\n        bottom: 0;\n        content: \"\";\n        display: block;\n        // height: 1.6px;\n        left: 50%;\n        position: absolute;\n        background:  $primary-btncolor;\n        transition: width 0.3s ease 0s, left 0.3s ease 0s;\n        width: 0;\n        border-bottom: 2px solid  $primary-btncolor;\n      }\n      .settingslinks:hover:after { \n        width: 100%; \n        left: 0; \n      }\n     \n     #layoutnav{\n        border-radius: 5px;\n     }\n\n      #addform{\n          margin-top: 30px;\n          padding: 30px;\n          border-radius: 10px;\n\n                .savebtn{\n                    border: none;\n                    border-radius: 5px;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    color: $white-color;\n                    font-size: 14px;\n                    margin-top: 10px;\n                    font-family: $sffont-regular;\n\n                    &:hover{\n                        background-color: $secondary-btncolor;\n                    }\n                }\n                .inputbox{\n                    padding: 5px;\n                    border: 1px solid #ced4da;\n                    border-radius: 5px;\n                    width: 100%;\n                    font-size: 14px;\n                }\n                .inputbox1{\n                    padding: 5px;\n                    border: none;\n                    border-radius: 5px;\n                    width: 100%;\n                    background-color: $darkthemecolor;\n                    color: $lightthemetext;\n                    font-family: $sffont-regular;\n                }\n                .formlabel{\n                    font-family: $sffont-regular;\n                    font-size: 14px;\n                }\n                .formlabel1{\n                    color: #f8f9fa;\n                    font-family: $sffont-regular;\n                    font-size: 12px;\n                }\n\n                .logo{\n                    border: 1px solid rgb(81 83 101 / 28%);\n                    padding: 10px;\n                    margin-bottom: 20px;\n                }\n                .editbtnsection{\n                    position: relative;\n                    margin-top: -37px;\n                }\n                \n                #penicon{\n                    margin-left:175px;\n                    font-size: 14px;\n                    background-color: $lightthemetext;\n                    padding: 5px;\n                    border-radius: 50%;\n                    color: #e9ecef;\n                    cursor: pointer;\n                \n                     &:hover{\n                        background-color: $primary-btncolor;\n                     }\n                }\n                \n      }\n}\n\n \n.upload{\n    border: 1px solid #dee2e6;\n    background-color: #f8f9fa;\n    padding: 6px 0px 0px 3px;\n    width: 90px;\n    margin-left: 205px;\n    margin-top: -45px;\n    border-radius:5px;\n}\n.uploadicon{\n    color: $black-color;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover{\n        color: $primary-btncolor;\n     }\n}\n.crossicon{\n    color: $black-color;\n    font-size: 16px;\n    margin-left: 40px;\n    cursor: pointer;\n\n    &:hover{\n       color: $primary-btncolor;\n     }\n\n}\n\n.navitemli{\n    margin-left: 20px;\n}\n\n\n\n@media only screen and (max-width: 878px) {\n   #layoutnav{\n    display: flex !important;\n   }\n   .settingslinks{\n    margin-right: 30px !important;\n   }\n}\n\n@media only screen and (max-width: 548px) {\n\n    .settingslinks{\n     margin-right: 20px !important;\n     font-size: 14px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 14px !important;\n    }\n }\n\n\n @media only screen and (max-width: 400px) {\n\n    .settingslinks{\n     margin-right: 0px !important;\n     font-size: 13px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 13px !important;\n    }\n }\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `settings_dashboard__FHk5D`,
	"cont2": `settings_cont2__VlNwH`,
	"bodythemelight": `settings_bodythemelight__daVLj`,
	"bodythemedark": `settings_bodythemedark__CUjRX`,
	"headerthemelight": `settings_headerthemelight__-DecU`,
	"headerthemedark": `settings_headerthemedark__VXMQL`,
	"menuthemelight": `settings_menuthemelight__xa936`,
	"menuthemedark": `settings_menuthemedark__0RlW9`,
	"menulinklight": `settings_menulinklight__2ukHf`,
	"menulinklightSelected": `settings_menulinklightSelected__-Sh8x`,
	"menulinkdarkSelected": `settings_menulinkdarkSelected__qg5eL`,
	"menulinkdark": `settings_menulinkdark__ZEp0Q`,
	"headinglight": `settings_headinglight__doSQ0`,
	"headingdark": `settings_headingdark__n+TEX`,
	"searchboxlight": `settings_searchboxlight__Exe8H`,
	"searchboxdark": `settings_searchboxdark__0LYGy`,
	"tableheadlight": `settings_tableheadlight__I2wDM`,
	"tableheaddark": `settings_tableheaddark__BAzcZ`,
	"tablebodylight": `settings_tablebodylight__F8haX`,
	"tablebodydark": `settings_tablebodydark__qeszF`,
	"paginationlight": `settings_paginationlight__BGULt`,
	"paginationdark": `settings_paginationdark__Hz6pf`,
	"formthemelight": `settings_formthemelight__HnEnB`,
	"formthemedark": `settings_formthemedark__ffb0i`,
	"viewformlight": `settings_viewformlight__AIIgi`,
	"viewformdark": `settings_viewformdark__a2qUr`,
	"permissionboxlight": `settings_permissionboxlight__UvL2i`,
	"permissionboxdark": `settings_permissionboxdark__qBhr4`,
	"errormsgclr": `settings_errormsgclr__QmeiF`,
	"graphclrlight": `settings_graphclrlight__rlfpD`,
	"graphclrdark": `settings_graphclrdark__tho2P`,
	"card1bglight": `settings_card1bglight__mR3L5`,
	"card1bgdark": `settings_card1bgdark__HX9ph`,
	"card2bglight": `settings_card2bglight__+y-JH`,
	"card2bgdark": `settings_card2bgdark__Kfhe7`,
	"card3bglight": `settings_card3bglight__XbcQO`,
	"card3bgdark": `settings_card3bgdark__ILj6B`,
	"card4bglight": `settings_card4bglight__fGD5L`,
	"card4bgdark": `settings_card4bgdark__0tK9O`,
	"actionbtnlight": `settings_actionbtnlight__4Sk0H`,
	"actionbtndark": `settings_actionbtndark__La-Jh`,
	"profiledropdownlight": `settings_profiledropdownlight__NbgyO`,
	"profiledropdowndark": `settings_profiledropdowndark__D0QpQ`,
	"settingsection": `settings_settingsection__xu5at`,
	"settingsheading": `settings_settingsheading__E8AHc`,
	"settingslinks": `settings_settingslinks__vcT1Z`,
	"settingsgeneral": `settings_settingsgeneral__0GBoO`,
	"layoutnav": `settings_layoutnav__xQYLn`,
	"addform": `settings_addform__Dk7Mj`,
	"savebtn": `settings_savebtn__yNpbe`,
	"inputbox": `settings_inputbox__7agbd`,
	"inputbox1": `settings_inputbox1__5RkFm`,
	"formlabel": `settings_formlabel__Bs5lx`,
	"formlabel1": `settings_formlabel1__b1qS9`,
	"logo": `settings_logo__2Nn6k`,
	"editbtnsection": `settings_editbtnsection__8ps9W`,
	"penicon": `settings_penicon__ZuNGm`,
	"upload": `settings_upload__Nn90h`,
	"uploadicon": `settings_uploadicon__tIHlL`,
	"crossicon": `settings_crossicon__Z8MI+`,
	"navitemli": `settings_navitemli__4IC51`,
	"dashboardcont2": `settings_dashboardcont2__qbjfj`
};
export default ___CSS_LOADER_EXPORT___;
